/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import countries from 'countries-list';
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { vatFormats, vatPlaceholder } from '../../utils/formatNumber';

const EditCustomerDialog = ({ show, onClose, onSubmit, title, customer, paymentTerms = [], globalData }) => {
  let countryCode = '';

  let updatedDefaultValue = customer;

  if (customer) {
    const characters = customer?.vatNumber?.match(/[a-zA-Z]+/g);
    const characterResult = characters ? characters.join('').slice(0, 2) : '';

    countryCode = characterResult;
    const numberResult = customer?.vatNumber?.slice(2);
    updatedDefaultValue = { ...customer, vatNumber: numberResult };
  }
  const {
    register,
    handleSubmit,
    watch,
    resetField,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: updatedDefaultValue,
  });
  const { t } = useTranslation();

  const isVATRegistred = watch('isVATRegistred');
  const [isVatRegisterSelected, setIsVatRegisterSelected] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  useEffect(() => {
    if (isInitialLoad && customer) {
      const vatStatus = customer.isVATRegistred === 'true' || customer.isVATRegistred === true;
      setIsVatRegisterSelected(vatStatus);
      setValue('isVATRegistred', vatStatus ? 'true' : 'false');
      setIsInitialLoad(false);
    }
  }, [customer, setValue, isInitialLoad]);
  useEffect(() => {
    if (!isInitialLoad) {
      setIsVatRegisterSelected(isVATRegistred === 'true');
    }
  }, [isVATRegistred, isInitialLoad]);

  const selectedPrefillCountry = watch('country');
  const accountType = watch('accountType');
  const [countryName, setCountryName] = useState('');
  const [countryVal, setCountryValue] = useState(false);
  const [VatNumberError, setVatNumberError] = useState('');
  const [vatCountryCode, setVatCountryCode] = useState(countryCode || "SE");
  const [useExistingPostal, setUseExistingPostal] = useState(true);
  const invoiceType = watch('invoiceType');
  const isSecondaryEmailAddress = watch('isSecondaryEmailAddress');
  const [secondaryChecked, setSecondaryChecked] = useState(false);
  const [isVatVerifiedChecked, setIsVatVerifiedChecked] = useState(customer?.isVatVerified === true);

  const newDetails = [];

  Object.keys(countries.countries).forEach((code) => {
    newDetails.push(countries.countries[code]);
  });

  Object.keys(countries.countries).forEach((code) => {
    if (countries.countries[code].name === countryName) {
      countryCode = code;
    }
    if (countryName === 'USA') {
      countryCode = 'US';
    }
  });

  useEffect(() => {
    setValue("vatCountryCode", vatCountryCode);
  }, [vatCountryCode, setValue]);

   const countryCodeOptions = Object.keys(countries.countries).map((code) => ({
    value: code,
    label: code,
  }));

  useEffect(() => {
    if (selectedPrefillCountry === 'Sweden') {
      setCountryValue(true);
    }
  }, [selectedPrefillCountry]);

   useEffect(() => {
    // Update vatCountryCode when countryName changes
    let code = "";
    Object.keys(countries.countries).forEach((c) => {
      if (countries.countries[c].name === countryName) {
        code = c;
      }
      if (countryName === "USA") {
        code = "US";
      }
    });
    if (code) setVatCountryCode(code);
  }, [countryName]);

  // Auto-set VAT registration when country is Sweden and account type is 3
  useEffect(() => {
    const currentCountry = watch('country') || countryName;
    const currentAccountType = accountType;
    
    if (currentCountry === 'Sweden' && (currentAccountType === '3' || currentAccountType === 3)) {
      setIsVatRegisterSelected(true);
      setValue('isVATRegistred', 'true');
    }
  }, [countryName, accountType, watch, setValue]);

  useEffect(() => {
    if (accountType === 1 || accountType === '1') {
      const getSSNVal = getValues('ssn');

      if (getSSNVal) {
        resetField('ssn', { defaultValue: getSSNVal });
      } else {
        resetField('ssn', { defaultValue: '' });
      }
    } else {
      const getORGVal = getValues('orgNo');
      if (getORGVal) {
        resetField('orgNo', { defaultValue: getORGVal });
      } else {
        resetField('orgNo', { defaultValue: '' });
      }
    }
  }, [accountType, getValues, resetField]);

  useEffect(() => {
    if (customer) {
      const postalAddr = customer?.postAddress || '';
      const postalCity = customer?.postCity || '';
      const postalCountry = customer?.postCountry || '';
      const postalZip = customer?.postZipCode || '';
      const postalCountryCode = customer?.postCountryCode || '';
      
      setValue('postAddress', postalAddr);
      setValue('postCity', postalCity);
      setValue('postCountry', postalCountry);
      setValue('postZipCode', postalZip);
      setValue('postCountryCode', postalCountryCode);
      
      const hasPostalData = Boolean(postalAddr || postalCity || postalCountry || postalZip || postalCountryCode);
      setUseExistingPostal(!hasPostalData);
      try {
        register && register('useExistingPostal');
      } catch (e) {
      }
      setValue('useExistingPostal', hasPostalData);
      
      const isSecondaryEmail = customer.isSecondaryEmailAddress === 'true' || customer.isSecondaryEmailAddress === true;
      setSecondaryChecked(!isSecondaryEmail);
    }
  }, [customer, setValue]);

  const countryOptions = [
    { value: 'Sweden', label: 'Sweden' },
    { value: 'USA', label: 'USA' },
    { value: 'Canada', label: 'Canada' },
    { value: 'Panama', label: 'Panama' },
    ...newDetails.map((country) => ({
      value: country.name,
      label: country.name,
    })),
  ];

  const customStyles = {
    control: (styles, { isFocused }) => {
      if (errors?.country) {
        styles.borderColor = '#dc3545';
      } else if (isFocused) {
        styles.borderColor = 'none';
        styles.boxShadow = '0 0 0 0 gray';
      }

      styles['&:hover'] = {
        borderColor: 'none',
      };

      styles.fontSize = '13px';

      return styles;
    },
  };

  const validateVatNumber = (countryCode, vatNumber) => {
    const format = vatFormats[countryCode];
    if (!format) {
      setVatNumberError('');
      return true;
    }
    const exampleFormat = vatFormats[countryCode]?.exampleFormat || "";
    const { regex, minLength, maxLength } = format;
    if (!regex.test(vatNumber)) {
      let errorMessage = '';
      if (vatNumber?.length < minLength || vatNumber?.length > maxLength) {
        errorMessage = `${t("Invalid VAT number format. It should be between")} ${minLength} ${t("and")} ${maxLength} ${t("digits long.")}`;
      } else {
        errorMessage = `${t("Invalid VAT number format. Expected format:")} ${exampleFormat}`;
      }
      setVatNumberError(errorMessage);
      return false;
    }
    setVatNumberError('');
    return true;
  };

  return (
    <Modal size="md" centered show={show} onHide={onClose} className="custom-top">
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <AiOutlineClose className="ml-auto cursor-pointer" size={24} onClick={onClose} />
      </Modal.Header>
      <form
        onSubmit={handleSubmit((values) => {
          values.vatCountryCode = vatCountryCode;
          values.IsVatVerified = isVatVerifiedChecked;
          if (isSecondaryEmailAddress === false || isSecondaryEmailAddress === 'false') {
            delete values.secondaryEmailAddress;
          }
          onSubmit(values);
        })}
      >
        <Modal.Body className="edit-customer">
          <div className="row flex-xs-column gap-0">
            {/* {!customer && ( */}
            <div className="col">
              <label htmlFor="account-type">{t('Business Type')}</label>
              <select
                id="account-type"
                type="text"
                className={`form-control form-control-md mb-3 ${errors.accountType ? 'is-invalid' : ''}`}
                {...register('accountType', {
                  required: true,
                })}
              >
                <option value="">{t('Select Account Type')}</option>
                {globalData &&
                  globalData.customerAccountType?.map((accountType) => (
                    <option key={accountType.key} value={accountType.value}>
                      {t(accountType.text)}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col">
              <label htmlFor="invoice-type">{t('Invoice Type')}</label>
              <select
                id="invoice-type"
                type="text"
                className={`form-control form-control-md mb-3 ${errors.invoiceType ? 'is-invalid' : ''}`}
                {...register('invoiceType', {
                  required: true,
                })}
              >
                <option value="" selected disabled>
                  {t('Select Invoice Type')}
                </option>
                <option value={1}>{t('Email (send to email address)')}</option>
                <option value={2}>{t('E-invoice (send as electronic invoice)')}</option>
                <option value={3}>{t('Post (60 SEK)')}</option>
              </select>
            </div>
          </div>
          {(invoiceType === '2' || invoiceType === 2) && (
            <>
              <div className="row flex-xs-column gap-0">
                <div className="col">
                  <label htmlFor="ourElectronicReference">{t('Our electronic reference')}</label>
                  <input
                    type="text"
                    id="ourElectronicReference"
                    className={`form-control form-control-md mb-3 ${errors.ourElectronicReference ? 'is-invalid' : ''}`}
                    placeholder={t('Our electronic reference')}
                    defaultValue="7230020"
                    readOnly
                    {...register('ourElectronicReference', {
                      required: false
                    })}
                  />
                </div>
                <div className="col col-md-6 col-sm-12">
                  <label htmlFor="yourElectronicReference">{t('Your electronic reference')}</label>
                  <input
                    type="text"
                    id="yourElectronicReference"
                    className={`form-control form-control-md mb-3 ${errors.yourElectronicReference ? 'is-invalid' : ''
                      }`}
                    placeholder={t('Your electronic reference')}
                    {...register('yourElectronicReference', {
                      required: true,
                    })}
                  />
                </div>
                <div className="col col-md-6 col-sm-12">
                  <label>GLN / Peppol ID</label>
                  <input
                    type="text"
                    className={`form-control form-control-md mb-3 ${errors.globalLocationNumber ? "is-invalid" : ""
                      }`}
                    placeholder={"GLN / Peppol ID"}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 18);
                    }}
                    {...register("globalLocationNumber",{
                      minLength:13,
                      maxLength:18
                    })}
                  />
                  <span>
                  {errors.globalLocationNumber && <p className="text-danger">{t('GLN should be 13 digits')}</p>}
                </span>
                </div>
              </div>
              <div className="row flex-xs-column gap-0">
                <div className="col">
                  <label htmlFor="extraField1">{t('Extra field 1 e-invoice (optional)')}</label>
                  <input
                    type="text"
                    id="extraField1"
                    className={`form-control form-control-md mb-3 ${errors.extraField1 ? 'is-invalid' : ''}`}
                    placeholder={t('Extra field 1 e-invoice')}
                    {...register('extraField1', {
                      required: false,
                    })}
                  />
                </div>
                <div className="col col-md-6 col-sm-12">
                  <label htmlFor="extraField2">{t('Extra field 2 e-invoice (optional)')}</label>
                  <input
                    type="text"
                    id="extraField2"
                    className={`form-control form-control-md mb-3 ${errors.extraField2 ? 'is-invalid' : ''}`}
                    placeholder={t('Extra field 2 e-invoice')}
                    {...register('extraField2', {
                      required: false,
                    })}
                  />
                </div>
              </div>
            </>
          )}
          <div className="row flex-xs-column gap-0">
            <div className="col">
              <label htmlFor="name">{t('Name')}</label>
              <input
                id="name"
                type="text"
                className={`form-control form-control-md mb-3 ${errors.name ? 'is-invalid' : ''}`}
                placeholder={t('Name')}
                {...register('name', {
                  required: true,
                })}
              />
            </div>
            {accountType === '1' || accountType === 1 ? (
              <div className="col">
                <label>{t("Your 12 digit SSN. No")}</label>
                <input
                  type="text"
                  className={`form-control form-control-lg mb-3 ${errors.ssn ? "is-invalid" : ""}`}
                  placeholder={t("Your 12 digit SSN. No")}
                  onKeyDown={(e) => {
                    const inputValue = e.key;
                    const allowedCharacters = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;
                    if (
                      inputValue !== "Backspace" &&
                      !allowedCharacters.test(inputValue) &&
                      ![
                        "Backspace",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                        "Delete",
                        "Control",
                        "v",
                        "Meta",
                      ].includes(inputValue) &&
                      !(e.ctrlKey || e.metaKey)
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onInput={(e) => {
                    const maxLength = 12;
                    e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                    if (e.target.value.length > maxLength) {
                      e.target.value = e.target.value.slice(0, maxLength);
                    }
                  }}
                  {...register("ssn", {
                    required: t("SSN is required"),
                    minLength: {
                      value: 12,
                      message: t("SSN must be exactly 12 digits")
                    },
                    maxLength: {
                      value: 12,
                      message: t("SSN must be exactly 12 digits")
                    },
                    validate: (value) => {
                      if (value && value.length === 12) {
                        const last4 = value.slice(-4);
                        if (last4 === "0000") {
                          return t("The last 4 digits of SSN cannot be all zeros.");
                        }
                      }
                      return true;
                    }
                  })}
                />
                <span>
                  {errors.ssn && (
                    <p className="text-danger" style={{ fontSize: "0.9em" }}>
                      {errors.ssn.message}
                    </p>
                  )}
                </span>
              </div>
            ) : (
              <div className="col">
                <label htmlFor="orgNo">{t('Org No')}</label>
                <input
                  id="orgNo"
                  type="text"
                  className={`form-control form-control-md mb-3 ${errors.orgNo ? 'is-invalid' : ''}`}
                  placeholder={t('Org No')}
                  {...register('orgNo', {
                    required: t('Org No is required'),
                    validate: (value) => {
                      const trimmedValue = value?.trim() || '';
                      if (!trimmedValue) {
                        return t('Org No is required');
                      }
                      if (!/[A-Za-z0-9]/.test(trimmedValue)) {
                        return t('Enter a valid Org No');
                      }
                      if (!/^[A-Za-z0-9-]+$/.test(trimmedValue)) {
                        return t('Org No can only contain letters, numbers, and hyphen');
                      }
                      return true;
                    },
                  })}
                />
                <span>
                  {errors.orgNo && (
                    <p className="text-danger" style={{ fontSize: '0.9em' }}>
                      {errors.orgNo.message}
                    </p>
                  )}
                </span>
              </div>
            )}
          </div>
          <div className="row flex-xs-column gap-0">
            <div className="col">
              <label htmlFor="phoneNumber">{t('Phone Number')}</label>
              <input
                id="phoneNumber"
                onKeyDown={(e) => {
                  if (e.ctrlKey || e.metaKey) {
                    return;
                  }
                  const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];
                  if (allowedKeys.includes(e.key)) {
                    return;
                  }
                  if (!/[0-9+()\-\s]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                className={`form-control form-control-md mb-3 ${errors.phoneNumber ? 'is-invalid' : ''}`}
                placeholder={t('Phone Number')}
                {...register('phoneNumber', {
                  required: t('Phone Number is required'),
                  validate: (value) => {
                    const trimmedValue = value?.trim() || '';
                    if (!trimmedValue) {
                      return t('Phone Number is required');
                    }
                    const normalized = trimmedValue.replace(/[\s()-]/g, '');
                    if (!/^\+?[0-9]+$/.test(normalized)) {
                      return t('Enter a valid Phone Number');
                    }
                    const digitsOnly = normalized.replace('+', '');
                    if (digitsOnly.length < 7 || digitsOnly.length > 15) {
                      return t('Phone Number must be between 7 and 15 digits');
                    }
                    return true;
                  },
                })}
              />
              <span>
                {errors.phoneNumber && (
                  <p className="text-danger" style={{ fontSize: '0.9em' }}>
                    {errors.phoneNumber.message}
                  </p>
                )}
              </span>
            </div>
            <div className="col">
              <label htmlFor="reference">{t('Reference')}</label>
              <input
                id="reference"
                type="text"
                className={`form-control form-control-md mb-3 ${errors.reference ? 'is-invalid' : ''}`}
                placeholder={t('Reference')}
                {...register('reference')}
              />
            </div>
          </div>
          <div className="row flex-xs-column gap-0">
            <div className="col">
              <label htmlFor="email">{t('Email')}</label>
              <input
                id="email"
                type="text"
                className={`form-control form-control-md mb-3 ${errors.email ? 'is-invalid' : ''}`}
                placeholder={t('Email')}
                {...register('email', {
                  required: invoiceType !== '3' && true,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Invalid email address',
                  },
                })}
              />
            </div>
            <div className="col">
              <label htmlFor="address">{t('Address')}</label>
              <input
                id="address"
                type="text"
                className={`form-control form-control-md mb-3 ${errors.address ? 'is-invalid' : ''}`}
                placeholder={t('Address')}
                {...register('address', {
                  required: true,
                })}
              />
            </div>
          </div>

          <div className="row flex-xs-column gap-0">
            {accountType !== '1' && accountType !== 1 && (
              <div className="col">
                <label htmlFor="address">{t('Address 2 (optional)')}</label>
                <input
                  id="address"
                  type="text"
                  className={`form-control form-control-md mb-3`}
                  placeholder={t('Address 2')}
                  {...register('address2')}
                />
              </div>
            )}
          </div>

          <div className="row flex-xs-column gap-0">
            <div className="col">
              <label htmlFor="city">{t('City')}</label>
              <input
                id="city"
                type="text"
                className={`form-control form-control-md mb-3 ${errors?.city ? 'is-invalid' : ''}`}
                placeholder={t('City')}
                {...register('city', {
                  required: true,
                })}
              />
            </div>

            <div className="col">
              <label htmlFor="zipCode">{t('Zip Code')}</label>
              <input
                id="zipCode"
                type="text"
                className={`form-control form-control-md mb-3 ${errors.zipCode ? 'is-invalid' : ''}`}
                placeholder={t('Zip Code')}
                {...register('zipCode', {
                  required: true,
                })}
                onInput={(e) => {
                  const maxLength = 9;
                  e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s,-]/g, '');
                  if (e.target.value.length > maxLength) {
                    e.target.value = e.target.value.slice(0, maxLength);
                  }
                }}
              />
            </div>
            {invoiceType === '3' && (
              <div className="col col-md-6 col-sm-12">
                <label htmlFor="careOf">{t('CareOf (C/O)')}</label>
                <input
                  type="text"
                  className={`form-control form-control-md mb-3 ${errors.careOf ? 'is-invalid' : ''}`}
                  placeholder={t('C/O')}
                  {...register('co')}
                />
              </div>
            )}
          </div>

          <div className="row flex-xs-column gap-0">
            <div className="col">
              <label htmlFor="country">{t('Country')}</label>
              <Select
                placeholder={t('Select Country')}
                styles={customStyles}
                defaultValue={countryOptions?.find((item) => item.label === customer?.country)}
                options={countryOptions}
                {...register('country', {
                  required: true,
                })}
                onChange={(selectedOption) => {
                  const selectedCountry = selectedOption.value;
                  if (selectedCountry === 'Sweden') {
                    setCountryValue(true);
                  } else {
                    setCountryValue(false);
                  }
                  setCountryName(selectedOption.value);
                  resetField('vatNumber', { defaultValue: '' });
                  if (!selectedCountry) {
                    setValue('country', '');
                  } else {
                    setValue('country', selectedOption.value);
                  }
                  setVatNumberError('');
                  
                  if (selectedCountry === 'Sweden' && (accountType === '3' || accountType === 3)) {
                    setIsVatRegisterSelected(true);
                    setValue('isVATRegistred', 'true');
                  }
                }}
              />
            </div>

            {accountType !== '1' && accountType !== 1 && isVatRegisterSelected && (
              <div className="col">
                <label htmlFor="vatNumber">{t('Vat. Number')}</label>
                <div className="select-box">
                 
                   <div className="arrow-downcheck">
                      {/* Dropdown for country code */}
                      <select
                        className="form-control form-control-sm"
                        style={{ width: 80, display: "inline-block",height: "40px" }}
                        value={vatCountryCode}
                        onChange={(e) => {
                          setVatCountryCode(e.target.value);
                          setValue("vatCountryCode", e.target.value); // keep form value in sync
                        }}
                      >
                        {countryCodeOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  <div className="input-box">
                    <input
                      min={4}
                      type="text"
                      placeholder={t(vatPlaceholder(vatCountryCode))} 
                      className={`form-control ${errors.vatNumber ? 'is-invalid' : ''}`}
                      onInput={(e) => {
                        setIsVatVerifiedChecked(false);
                        const allowedCharacters = vatFormats[vatCountryCode]?.allowedCharacters || /^[A-Za-z0-9]*$/;
                        e.target.value = e.target.value.replace(/[^A-Za-z0-9]/g, '');
                        const maxLength = vatFormats[vatCountryCode]?.maxLength || 18;
                        if (e.target.value.length > maxLength) {
                          e.target.value = e.target.value.slice(0, maxLength);
                        }
                        Object.keys(countries.countries).forEach((code) => {
                          if (countries.countries[code].name === selectedPrefillCountry) {
                            countryCode = code;
                          }
                        });
                      }}
                      onKeyDown={(e) => {
                        const allowedCharacters = vatFormats[vatCountryCode]?.allowedCharacters || /^[A-Za-z0-9]*$/;
                        if (
                          allowedCharacters.test(e.key) ||
                          ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)
                        ) {
                          return true;
                           // eslint-disable-next-line no-else-return
                        } else {
                          e.preventDefault();
                          return false;
                        }
                      }}
                      {...register('vatNumber', {
                        required: countryVal === false && accountType !== '1' && accountType !== 1,
                        validate: (value) => validateVatNumber(countryCode, value),
                      })}
                    />
                  </div>
                </div>
                {VatNumberError !== '' && <span className="vatNumberError">{VatNumberError}</span>}
                <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
                  <input
                    id="isVatVerifiedCheckbox"
                    type="checkbox"
                    checked={isVatVerifiedChecked}
                    disabled={!watch('vatNumber')}
                    onChange={(e) => setIsVatVerifiedChecked(e.target.checked)}
                    style={{ width: 16, height: 16, cursor: watch('vatNumber') ? 'pointer' : 'not-allowed' }}
                    title={!watch('vatNumber') ? t('Enter a VAT number before marking as verified') : ''}
                  />
                  <label
                    htmlFor="isVatVerifiedCheckbox"
                    style={{ marginBottom: 0, fontSize: 14, cursor: watch('vatNumber') ? 'pointer' : 'not-allowed', color: !watch('vatNumber') ? '#aaa' : 'inherit' }}
                  >
                    {t('VAT Verified')}
                  </label>
                </div>
              </div>
            )}
          </div>
          <div className="row flex-xs-column mt-2 gap-0">
            <div className="col">
              <label htmlFor="payment">{t('Payment Term')}</label>
              <select
                id="payment"
                type="text"
                className={`form-control form-control-md mb-3 ${errors.paymentTerm ? 'is-invalid' : ''}`}
                {...register('paymentTerm', {
                  required: true,
                })}
              >
                <option value="">{t('Payment Term')}</option>
                {paymentTerms?.map((paymentTerm) => (
                  <option key={paymentTerm.id} value={paymentTerm.globalValue}>
                    {paymentTerm.globalValue} {t('days')}
                  </option>
                ))}
              </select>
            </div>
          </div>
          
          {/* Postal delivery checkbox and conditional fields */}
          {(invoiceType === '3' || invoiceType === 3) && (
            <div className="row flex-xs-column gap-0" style={{ marginTop: '12px' }}>
              <div className="col">
                <div className="form-check mb-3">

                  <input
                    id="useExistingPostal"
                    type="checkbox"
                    className="form-check-input"
                    checked={useExistingPostal}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setUseExistingPostal(checked);
                      // Keep form field in sync with inverted boolean:
                      // when checked -> send false, when unchecked -> send true
                      setValue('useExistingPostal', !checked);
                      if (checked) {
                        setValue('postAddress', '');
                        setValue('postCity', '');
                        setValue('postCountry', '');
                        setValue('postZipCode', '');
                        setValue('postCountryCode', '');
                      }
                    }}
                  />

                  <label htmlFor="useExistingPostal" className="form-check-label">
                    {t('Use existing address for postal delivery')} (
                    {(watch('address') || customer?.address || '') +
                      ((watch('city') || customer?.city) ? ', ' + (watch('city') || customer?.city) : '') +
                      ((watch('zipCode') || customer?.zipCode) ? ', ' + (watch('zipCode') || customer?.zipCode) : '') +
                      ((watch('country') || customer?.country) ? ', ' + (watch('country') || customer?.country) : '')}
                    )
                  </label>
                </div>
              </div>
            </div>
          )}
          {!useExistingPostal && (
            <>
              <div className="row flex-xs-column gap-0">
                <div className="col">
                  <label htmlFor="postalAddress">{t('Postal Address')}</label>
                  <input
                    id="postalAddress"
                    type="text"
                    className={`form-control form-control-md mb-3 ${errors.postAddress ? 'is-invalid' : ''}`}
                    placeholder={t('Type here....')}
                    {...register('postAddress', {
                      required: true,
                    })}
                  />
                </div>
              </div>

              <div className="row flex-xs-column gap-0">
                <div className="col">
                  <label htmlFor="postCity">{t('Postal City')}</label>
                  <input
                    id="postCity"
                    type="text"
                    className={`form-control form-control-md mb-3 ${errors.postCity ? 'is-invalid' : ''}`}
                    placeholder={t('Type here....')}
                    {...register('postCity', {
                      required: true,
                    })}
                  />
                </div>
              </div>

              <div className="row flex-xs-column gap-0">
                <div className="col">
                  <label htmlFor="postCountry">{t('Postal Country')}</label>
                  <Select
                    placeholder={t('Select')}
                    styles={customStyles}
                    defaultValue={countryOptions?.find((item) => item.label === watch('postCountry'))}
                    options={countryOptions}
                    {...register('postCountry', {
                      required: true,
                    })}
                    onChange={(selectedOption) => {
                      setValue('postCountry', selectedOption?.value || '');
                      Object.keys(countries.countries).forEach((code) => {
                        if (countries.countries[code].name === selectedOption?.value) {
                          setValue('postCountryCode', code);
                        }
                        if (selectedOption?.value === 'USA') {
                          setValue('postCountryCode', 'US');
                        }
                      });
                    }}
                  />
                </div>
              </div>

              <div className="row flex-xs-column gap-0">
                <div className="col">
                  <label htmlFor="postZipCode">{t('Postal Zip Code')}</label>
                  <input
                    id="postZipCode"
                    type="text"
                    className={`form-control form-control-md mb-3 ${errors.postZipCode ? 'is-invalid' : ''}`}
                    placeholder={t('Type here....')}
                    {...register('postZipCode', {
                      required: true,
                    })}
                    onInput={(e) => {
                      const maxLength = 9;
                      e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s,-]/g, '');
                      if (e.target.value.length > maxLength) {
                        e.target.value = e.target.value.slice(0, maxLength);
                      }
                    }}
                  />
                </div>

                <div className="col">
                  <label htmlFor="postalCountryCode">{t('Postal Country Code')}</label>
                  <select
                    id="postCountryCode"
                    className="form-control form-control-md mb-3"
                    value={watch('postCountryCode') || ''}
                    {...register('postCountryCode', {
                      required: true,
                    })}
                    onChange={(e) => setValue('postCountryCode', e.target.value)}
                  >
                    <option value="">{t('Select')}</option>
                    {countryCodeOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </>
          )}

          {accountType !== '1' && accountType !== 1 && (
            <div className="row flex-xs-column mt-1 gap-0">
              <div className="col">
                <label htmlFor="have_vatnumber">{t('Do you have VAT number?')}</label>
                <select
                  id="have_vatnumber"
                  className="form-control form-control-md mb-3"
                  {...register('isVATRegistred', { required: true })}
                  defaultValue={isVatRegisterSelected ? 'true' : 'false'}
                  disabled={(watch('country') === 'Sweden' || countryName === 'Sweden') && (accountType === '3' || accountType === 3)}
                  onChange={(e) => {
                    const value = e.target.value === 'true';
                    setIsVatRegisterSelected(value); // Update the state based on user selection
                    setValue('isVATRegistred', e.target.value); // Update the form value for isVATRegistred
                  }}
                >
                  <option value="true">{t('Yes')}</option>
                  <option value="false">{t('No')}</option>
                </select>
              </div>
            </div>
          )}

          {(invoiceType === '1' || invoiceType === 1) && (
            <>
            <div className="col d-flex align-items-center">
              <div className="form-check mb-3">
                <input
                  id="isSecondaryEmailAddress"
                  type="checkbox"
                  className="form-check-input"
                  checked={secondaryChecked}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setSecondaryChecked(checked);
                    try {
                      register && register('isSecondaryEmailAddress');
                    } catch (err) {
                    }
                    setValue('isSecondaryEmailAddress', !checked);
                  }}
                />
                <label htmlFor="isSecondaryEmailAddress" className="form-check-label">
                  {t(`Add secondary email field for customer( ${customer?.email ?? ''} )`)}
                </label>
              </div>
            </div>
          {!secondaryChecked && (
            <div className="row flex-xs-column gap-0">
              <div className="col">
                <label htmlFor="secondaryEmailAddress">{t('Secondary Email')}</label>
                <input
                  id="secondaryEmailAddress"
                  type="email"
                  className={`form-control form-control-md mb-3 ${errors.secondaryEmail ? 'is-invalid' : ''}`}
                  placeholder={t('Secondary Email')}
                  {...register('secondaryEmailAddress', {
                    required: true,
                    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  })}
                />
              </div>
            </div>
          )}
  </>
)}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            {t('Close')}
          </Button>
          <Button className="text-light" variant="primary" type="subnit">
            {t('Save')}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default EditCustomerDialog;
